export default class AdditionalCodeCreation {
  name = ""
  descriptionFromCodeAcv = ""
  lot = ""
  sousLot = ""
}
